'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isArrayLike;
function isArrayLike(value) {
    return value && typeof value.length === 'number' && value.length >= 0 && value.length % 1 === 0;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/async/internal/isArrayLike.js
// module id = 5r0d
// module chunks = 0